module.exports = __webpack_public_path__ + "assets/e70c4b91e296d529e13097300387f551.svg";